import create from "zustand";
export const createActiveIdSlice = (set) => ({
  activeId: "0",
  state0: () => set({ activeId: "0" }),
  state1: () => set({ activeId: "1" }),
});
